import script from "./RecursiveSelectorNode.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecursiveSelectorNode.vue?vue&type=script&setup=true&lang=ts"

import "./RecursiveSelectorNode.vue?vue&type=style&index=0&id=889f2f82&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-889f2f82"]])

export default __exports__